import { ApolloLink } from '@apollo/client';
import { removeKeyRecursively } from '@seek/ca-myprofile-utils';
import { metrics } from '@seek/metrics-js';

export const OmitTypenameLink = new ApolloLink((operation, forward) => {
  if (operation.variables) {
    operation.variables = removeKeyRecursively(
      operation.variables,
      '__typename',
    );
  }

  return forward(operation);
});

const autosuggestOperations = [
  'getRoleTitle',
  'getOrganisations',
  'getQualifications',
  'getEducationProviders',
  'getSpecReqs',
];

export const AutosuggestTimingLink = new ApolloLink((operation, forward) => {
  // Called before operation is sent to server
  const isAutosuggestOperation = autosuggestOperations.includes(
    operation.operationName,
  );

  if (isAutosuggestOperation) {
    operation.setContext({ start: performance.now() });
  }

  return forward(operation).map((data) => {
    // Called after server responds
    if (isAutosuggestOperation) {
      const duration = performance.now() - operation.getContext().start;
      metrics.timing('autosuggest', duration, [
        `query:${operation.operationName}`,
      ]);
    }

    return data;
  });
});
